<script>
export default {
  name: "f-add",
};
</script>

<template>
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 56.33 42.49"
  >
    <defs>
      <clipPath id="clippath">
        <polygon
          class="cls-2"
          points="56.33 42.49 0 42.38 0 0 56.33 0 56.33 42.49"
        />
      </clipPath>
    </defs>
    <g id="FL_Online">
      <g class="cls-5">
        <g>
          <g>
            <g>
              <path
                class="cls-1"
                d="m15.51,19.45c-.65.51-1.43,1.2-2.26,2.04-.18,0-.35.02-.53.02-4.33,0-7.84-3.51-7.84-7.84s3.51-7.85,7.84-7.85c.22,0,.45,0,.67.03-.58,1.53-.89,3.19-.89,4.92,0,3.28,1.13,6.28,3.01,8.69Z"
              />
              <path
                class="cls-1"
                d="m11.54,23.4c-2.19,2.7-4.44,6.52-5.6,11.61-.1.47-.18.95-.2,1.42h-1.81c-2.52,0-4.39-2.35-3.83-4.8,1.33-5.87,4.89-9.06,6.56-10.27,1.37,1.08,3.05,1.82,4.89,2.03Z"
              />
            </g>
            <g>
              <circle class="cls-4" cx="25.18" cy="10.86" r="10.86" />
              <path
                class="cls-4"
                d="m37.38,42.45l-24.41-.05c-3.49,0-6.08-3.22-5.31-6.63,1.85-8.15,6.79-12.58,9.09-14.25,2.32,1.83,5.24,2.93,8.42,2.93s6.11-1.1,8.42-2.93c2.3,1.67,7.24,6.1,9.09,14.25.78,3.41-1.81,6.68-5.31,6.68Z"
              />
            </g>
          </g>
          <rect
            class="cls-3"
            x="43.25"
            y="9.02"
            width="6.28"
            height="19.88"
            rx="3.11"
            ry="3.11"
          />
          <rect
            class="cls-3"
            x="43.25"
            y="9.02"
            width="6.28"
            height="19.88"
            rx="3.11"
            ry="3.11"
            transform="translate(65.35 -27.43) rotate(90)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style scoped lang="scss">
.cls-1 {
  fill: #cb922e;
}

.cls-1,
.cls-2,
.cls-3,
.cls-4 {
  stroke-width: 0px;
}

.cls-2 {
  fill: none;
}

.cls-3 {
  fill: #fff;
}

.cls-5 {
  clip-path: url(#clippath);
}

.cls-4 {
  fill: #ffc713;
}
</style>
